import { APPLY_JOB_IDS, APPLY_PROJECT_ID } from '../constants/jobData';

export function isMobileDevice() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(max-width:767px)').matches ||
    /Android|iPhone|iPad|iPod|Mobile|IEMobile|Opera Mini/i.test(navigator.userAgent)
  );
}

export function getApplyUrl(jobId, mobile = isMobileDevice()) {
  if (mobile) {
    return 'https://matsc.liepin.com/ats/apply-form/apply-job-list/?jobId=ed3fff30ed598e0be35742e323d7a7b1&projectId=f0eb37ef2977acd71193f7e9590e4783';
  }
  return 'https://atsc.liepin.com/ats/apply-form/?jobId=ed3fff30ed598e0be35742e323d7a7b1&projectId=f0eb37ef2977acd71193f7e9590e4783';
}
